import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { GetTranslateServerSideStateServiceImpl } from './services/impls/get-translate-server-side-state-service';
import { GetRecommendTranslateKeywordServiceImpl } from './services/impls/get-recommend-translate-keyword-service';
import { CreateAsyncTranslateTaskServiceImpl } from './services/impls/create-async-translate-task-service';
import { CreateSyncTranslateTaskServiceImpl } from './services/impls/create-sync-translate-task-service';
import { TranslateServerSideModel } from './models/translate-server-side-model';
import { TranslateServerSideModelImpl } from './models/impls/translate-task-status-model';
import { CreateAsyncTranslateTaskService } from './services/create-async-translate-task-service';
import { CreateSyncTranslateTaskService } from './services/create-sync-translate-task-service';
import { GetRecommendTranslateKeywordService } from './services/get-recommend-translate-keyword-service';
import { GetTranslateServerSideStateService } from './services/get-translate-task-status-service';
import { TranslateStageControllerImpl } from './services/impls/translate-stage-controller';
import { TranslateStageController } from './services/translate-stage-controller';
import { TranslateStageInitial } from './services/impls/translate-stage-initial';
import { TranslateStage } from './services/translate-stage';
import { TranslateStageResult } from './services/impls/translate-stage-result';
import { TranslateStageWaiting } from './services/impls/translate-stage-waiting';
import { GetTranslateSegmentsServiceImpl } from './services/impls/get-translate-segments-service';
import { GetTranslateSegmentsService } from './services/get-translate-segments-service';
import { TranslateStagePreview } from './services/impls/translate-stage-preview';
import { TranslationTaskNameManager } from './services/impls/task-name-manager';
import { TranslationTaskNameGetter, TranslationTaskNameSetter } from './services/task-name-manager';
import { TranslateLoadingService } from './services/translate-loading-service';
import { TranslateLoadingServiceImpl } from './services/impls/translate-loading-service';
import { TranslateFragmentInTaskImpl } from './services/impls/translate-fragment-in-task';
import { TranslateFragmentInTask } from './services/translate-fragment-in-task';
import { UpdateFragmentTranslationImpl } from './services/impls/update-fragment-translation';
import { UpdateFragmentTranslation } from './services/update-fragment-translation';
import { TranslationEditorImpl } from './services/impls/translation-editor';
import { TranslationEditor } from './services/translation-editor';
import { OriginalInputModelImpl } from './models/impls/original-input-model';
import { OriginalInputModel } from './models/original-input-model';
import { OriginalInputServiceImpl } from './services/impls/original-input-service';
import { OriginalInputService } from './services/original-input-service';
import { AITranslationModelImpl } from './models/impls/translate-model';
import { TranslateModel } from './models/translate-model';
import { SuggestionModelImpl } from './models/impls/suggestion-model';
import { SuggestionModel } from './models/suggestion-model';
import { SuggestionServiceImpl } from './services/impls/suggestion-service';
import { SuggestionService } from './services/suggestion-service';

export const translateBotModule = new ContainerModule((bind) => {
    bind(GetRecommendTranslateKeywordService).to(GetRecommendTranslateKeywordServiceImpl);
    bind(GetTranslateServerSideStateService).to(GetTranslateServerSideStateServiceImpl);
    bind(TranslateServerSideModel).to(TranslateServerSideModelImpl);
    bind(TranslateLoadingService).to(TranslateLoadingServiceImpl);

    bind(CreateAsyncTranslateTaskService).to(CreateAsyncTranslateTaskServiceImpl);
    bind(CreateSyncTranslateTaskService).to(CreateSyncTranslateTaskServiceImpl);
    bind(GetTranslateSegmentsService).to(GetTranslateSegmentsServiceImpl);

    bind(TranslateStageController).to(TranslateStageControllerImpl);
    bind(TranslateStage).to(TranslateStageInitial);
    bind(TranslateStage).to(TranslateStageWaiting);
    bind(TranslateStage).to(TranslateStageResult);
    bind(TranslateStage).to(TranslateStagePreview);

    bind(TranslationTaskNameManager).toSelf();
    bind(TranslationTaskNameGetter).toService(TranslationTaskNameManager);
    bind(TranslationTaskNameSetter).toService(TranslationTaskNameManager);

    bind(TranslateFragmentInTask).to(TranslateFragmentInTaskImpl);
    bind(UpdateFragmentTranslation).to(UpdateFragmentTranslationImpl);
    bind(TranslationEditor).to(TranslationEditorImpl);

    bind(OriginalInputService).to(OriginalInputServiceImpl);
    bind(OriginalInputModel).to(OriginalInputModelImpl);
    bind(TranslateModel).to(AITranslationModelImpl);
    bind(SuggestionModel).to(SuggestionModelImpl);
    bind(SuggestionService).to(SuggestionServiceImpl);
});
